import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import storageConnectivityReducers, {
  storageConnectivityKey,
} from 'app/plugins/infrastructure/components/common/service-health/storage-connectivity/reducers'
import cacheReducers, {
  cacheStoreKey,
  dataStoreKey,
  lastRefreshTimeStoreKey,
  loadingStoreKey,
  paramsStoreKey,
  updatingStoreKey,
} from 'core/caching/cacheReducers'
import clientReducers, { clientStoreKey } from 'core/client/clientReducers'
import notificationReducers, { notificationStoreKey } from 'core/notifications/notificationReducers'
import chameleonReducers, { chameleonKey } from 'core/session/chameleonReducers'
import permissionsReducers, { permissionsKey } from 'core/session/permissionsReducers'
import preferencesReducers, { preferencesStoreKey } from 'core/session/preferencesReducers'
import sessionReducers, { sessionStoreKey } from 'core/session/sessionReducers'
import themeReducers, { customThemeKey } from 'core/session/themeReducers'
import migrationReducers, { customMigrationKey } from 'openstack/components/vms/migrations/reducers'

const persistCacheConfig = {
  key: cacheStoreKey,
  storage,
  blacklist: [
    loadingStoreKey,
    dataStoreKey,
    updatingStoreKey,
    paramsStoreKey,
    lastRefreshTimeStoreKey,
  ],
}

const persistClientConfig = {
  key: clientStoreKey,
  storage,
  blacklist: ['frame'],
}

const persistSessionConfig = {
  key: sessionStoreKey,
  storage,
  blacklist: [
    'loadingRegion',
    'vmsLastPolledTimestamp',
    'volumesLastPolledTimestamp',
    'availableVolumesLastPolledTimestamp',
  ],
}

const persistMigrationConfig = {
  key: customMigrationKey,
  storage,
  blacklist: ['lastMigrationByVmId'],
}

const persistChameleonConfig = {
  key: chameleonKey,
  storage,
  blacklist: ['createdVmId', 'migratedVmId'],
}

const persistStorageConnectivityConfig = {
  key: storageConnectivityKey,
  storage,
  blacklist: ['running'],
}

const rootReducer = combineReducers({
  [sessionStoreKey]: persistReducer(persistSessionConfig, sessionReducers),
  [cacheStoreKey]: persistReducer(persistCacheConfig, cacheReducers),
  [notificationStoreKey]: notificationReducers,
  [preferencesStoreKey]: preferencesReducers,
  [customThemeKey]: themeReducers,
  [clientStoreKey]: persistReducer(persistClientConfig, clientReducers),
  [customMigrationKey]: persistReducer(persistMigrationConfig, migrationReducers),
  [chameleonKey]: persistReducer(persistChameleonConfig, chameleonReducers),
  [permissionsKey]: permissionsReducers,
  [storageConnectivityKey]: persistReducer(
    persistStorageConnectivityConfig,
    storageConnectivityReducers,
  ),
})

export default rootReducer
